<div class="datagrid-form">
  <div class="form-group">
    <label for="name" class="schedular-label">Name <span class="required"><i class="fa fa-asterisk"></i></span></label>
    <div class="datagrid__fields">
      <input [disabled]="!cxSchedularService.editMode" [(ngModel)]="data.name" type="text" class="form-control" placeholder="Name" />
    </div>
  </div>

  <div class="form-group dg-mb-3">
    <label for="name" class="schedular-label">View <span class="required"><i class="fa fa-asterisk"></i></span></label>
    <f-dropdown [disabled]="!cxSchedularService.editMode" [style]="{ minWidth: '100%' }" [(ngModel)]="data.view_id" [options]="__views"
      placeholder="Select a view" optionLabel="name" optionValue="id">
      <ng-template let-item pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>{{ item.name }}</div>
        </div>
      </ng-template>
    </f-dropdown>
  </div>

  <div class="form-group dg-mb-3">
    <label for="name" class="schedular-label">Location <span class="required"><i class="fa fa-asterisk"></i></span></label>
    <f-dropdown [disabled]="!cxSchedularService.editMode" [style]="{ minWidth: '100%' }" [(ngModel)]="data.location" [options]="cxSchedularService.locations"
      placeholder="Select a location" optionLabel="name" optionValue="value">
      <ng-template let-item pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>{{ item.name }}</div>
        </div>
      </ng-template>
    </f-dropdown>
  </div>

  @if (data.location === 'end') {
    <div class="form-group dg-mb-3">
      <label for="name" class="schedular-label" st>Email Addresses <span class="required"><i class="fa fa-asterisk"></i></span></label>
      <p class="schedular-label">(Hit Enter key to add more)</p>
      <p-chips [showClear]="true" [disabled]="!cxSchedularService.editMode" name="emailAddresses" [style]="{ width: '100%' }" placeholder="abx@gmail.com"
        [(ngModel)]="data.addresses"></p-chips>

      <p class="error-field">{{ emailValidMessage }}</p>
    </div>
  }

  <div class="form-group dg-mb-3">
    <label for="ft" class="schedular-label">File type <span class="required"><i class="fa fa-asterisk"></i></span></label>
    <f-dropdown [disabled]="!cxSchedularService.editMode" id="ft" [style]="{ minWidth: '100%' }" [(ngModel)]="data.type"
      [options]="cxSchedularService.fileTypes" placeholder="Select a type" optionLabel="name" optionValue="value">
      <ng-template let-item pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>{{ item.name }}</div>
        </div>
      </ng-template>
    </f-dropdown>
  </div>

  <div class="form-group dg-mb-3">
    <label for="sc" class="schedular-label">Schedule Time <span class="required"><i class="fa fa-asterisk"></i></span></label>
    <f-dropdown [disabled]="!cxSchedularService.editMode" id="sc" [style]="{ minWidth: '100%' }" [(ngModel)]="data.cron_label"
      [options]="cxSchedularService.schedulars" placeholder="Select time" optionLabel="name" optionValue="value">
      <ng-template let-item pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>{{ item.name }}</div>
        </div>
      </ng-template>
    </f-dropdown>
  </div>

  @if (data.cron_label === 'custom') {
    <div class="form-group dg-mb-3">
      <label for="name" class="schedular-label">Custom</label>
      <p-calendar [minDate]="minDate" [disabled]="!cxSchedularService.editMode" id="name" [(ngModel)]="data.cron_expression" [showTime]="true" [inline]="true"></p-calendar>
    </div>
  }

  @if (cxSchedularService.edit_id && cxSchedularService.editMode) {
    <button [disabled]="!cxSchedularService.edit_id || !data.name || !data.view_id || !data.location || !data.type || !data.cron_label" (click)="onUpdate($event)" class="btn-bg">Update</button>
  } @else if (cxSchedularService.editMode) {
    <button [disabled]="!data.name || !data.view_id || !data.location || !data.type || !data.cron_label" (click)="onCreate($event)" class="btn-bg">Create</button>
  }
</div>